import { useMutation, useQuery } from "@tanstack/react-query";
import { exportPedidoReports, listPedidoReports } from "./api";
import type { PedidoReportRef } from "./types";

export const PEDIDO_REPORT_QUERY_KEY = ["reports", "pedidos"] as const;

export function usePedidoReports(date: string) {
  return useQuery({
    queryKey: [...PEDIDO_REPORT_QUERY_KEY, date],
    queryFn: ({ signal }) => listPedidoReports(date, signal),
  });
}

export function useExportPedidoReports() {
  return useMutation({
    mutationFn: ({
      date,
      orders,
    }: {
      date: string;
      orders: PedidoReportRef[];
    }) => exportPedidoReports(date, orders),
  });
}
